export default __webpack_public_path__ + "static/media/Weather-App.2b1d5f6e.PNG";